/**
 * Loading.jsx - Full-screen loading spinner overlay.
 *
 * Displays a semi-transparent backdrop with a centered spinning circle.
 * Typically shown during initial data fetches or long operations.
 *
 * Props:
 *   show  {boolean}  - When true the overlay is visible; when false nothing renders.
 *   text  {string}   - Optional message displayed below the spinner.
 *
 * Usage:
 *   <Loading show={isLoading} text="Loading vendors..." />
 */

export default function Loading({ show, text }) {
  if (!show) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.content}>
        <div style={styles.spinner} />
        {text && <p style={styles.text}>{text}</p>}
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* Styles                                                              */
/* ------------------------------------------------------------------ */

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 10000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0, 0, 0, 0.32)",
    backdropFilter: "blur(2px)",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 14,
  },
  spinner: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    border: "3px solid var(--line)",
    borderTopColor: "var(--accent)",
    animation: "spin 0.7s linear infinite",
  },
  text: {
    color: "var(--ink-2)",
    fontSize: 13,
    fontWeight: 550,
  },
};
